/** 日本語. See `en.ts` for what each key is and what it has to fit. */

import type { MessageKey } from "./en";

export const ja: Record<MessageKey, string> = {
  metaDescription:
    "無料のリアルタイム気象マップをブラウザで：GFS・ECMWF・AIFS の数値予報、レーダーと衛星画像のアニメーション、台風の進路、3D レーダー、スキューT図。",
  pageTitleLive: "{variable}の予報図 · {model} {hours}H",
  pageTitleLiveObservation: "{variable}の観測図 · {model} · 直近{hours}時間",
  mapAria: "全球の気温・降水予報図",
  modelSwitchAria: "データセット",
  variableSwitchAria: "気象要素",
  varTemp: "気温",
  varPrecip: "降水",
  varWind: "風",
  varSolar: "日射",
  varRadar: "レーダー",
  varOrog: "地形",
  varInfrared: "赤外 10.4",
  varShortwave: "短波 3.9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "カラー",
  varGust: "突風",
  varCloud: "雲量",
  varCape: "対流",
  varPwat: "気柱",
  varPtype: "種別",
  varCin: "抑制",
  varHpbl: "高度",
  varVis: "視程",
  varDewPoint: "露点",
  varFeelsLike: "体感",
  varOmega: "鉛直",
  varThetaE: "相当温位",
  varCat: "晴天乱気流",
  varInflow: "暖湿流",
  varFront: "前線帯",
  varHotspot: "高温点",
  varFfwi: "火災気象",
  varFwalert: "乾燥強風",
  varSst: "海面",
  varIce: "海氷",
  varWave: "波浪",
  varAod: "全体",
  varPm: "2.5",
  varDustsfc: "黄砂",
  varTsoil: "地温",
  varSoilw: "土壌水分",
  varHumidity: "相対",
  varVapourFlux: "水蒸気",
  varPressure: "海面",
  varHeight: "高度",
  varPressureField: "気圧場",
  varUnknownLayer: "レイヤ",

  glyphTmp2m: "温",
  glyphPrate: "水",
  glyphWind10m: "風",
  glyphDswrf: "日",
  glyphCref: "雷",
  glyphIr104: "衛",
  glyphIr039: "短",
  glyphDustrgb: "塵",
  glyphDustcf: "信",
  glyphZhouye: "昼",
  glyphTruecolor: "彩",
  glyphGust: "突",
  glyphTcdc: "雲",
  glyphCape: "対",
  glyphVis: "視",
  glyphPwat: "柱",
  glyphCin: "抑",
  glyphHpbl: "層",
  glyphPtype: "型",
  glyphDpt2m: "露",
  glyphAptmp2m: "感",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "暖",
  glyphFront: "前",
  glyphHotspot: "熱",
  glyphFfwi: "火",
  glyphFwalert: "警",
  glyphTmpsfc: "海",
  glyphIce: "氷",
  glyphWave: "波",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "砂",
  glyphTsoil: "地",
  glyphSoilw: "土",
  glyphPressure: "圧",
  glyphRh: "湿",
  glyphQflux: "汽",
  tipTemp: "気温",
  tipHumidity: "相対湿度",
  tipWind: "風",
  tipPressure: "気圧・ジオポテンシャル高度",
  tipVapourFlux: "水蒸気フラックス",
  tipCloud: "雲量",
  tipOmega: "鉛直速度",
  tipThetaE: "相当温位",
  tipCat: "晴天乱気流",
  tipIce: "海氷",
  tipWave: "波浪",
  tipAod: "エーロゾル光学的厚さ",
  tipPm: "粒子状物質",
  tipTsoil: "地温",
  tipSoilw: "土壌水分",
  tipSatellite: "衛星画像",
  levelSwitchAria: "気圧面",
  levelCaption: "気圧面",
  linesCaption: "等圧線",
  accumCaption: "積算",
  accumRateGloss: "降水強度",
  accumTotalGloss: "{window} 積算",
  modelHeading: "データセット",
  linesRemoveTitle: "もう一度押すと等値線を消します",
  fieldSectionAria: "塗り分け",
  overlaySectionAria: "重ね描き",
  markSectionAria: "マーク",
  tipMore: "この実行の全レイヤ",
  varMore: "レイヤ",
  glyphMore: "+",
  fieldSheetAria: "レイヤ",
  fieldSheetHeading: "レイヤ",
  fieldGroupTemperature: "気温",
  fieldGroupMoisture: "水分",
  fieldGroupSoil: "土壌",
  fieldGroupWind: "風",
  fieldGroupDynamics: "力学",
  fieldGroupRadiation: "放射と視程",
  fieldGroupAerosol: "エーロゾルと大気質",
  fieldGroupOcean: "海洋",
  fieldGroupHydrology: "河川・洪水",
  fieldGroupSatellite: "衛星",
  fieldGroupOther: "その他",
  fieldGroupImagery: "日次画像：NASA GIBS",
  gibsTrueColor: "トゥルー",
  gibsFalseColor: "火災",
  gibsTipTrue: "トゥルーカラー",
  gibsTipFire: "火災フォールスカラー：焼け跡は暗赤色",
  varParticles: "粒子",
  glyphParticles: "粒",
  varVolume: "3D雲",
  glyphVolume: "体",
  levelAlone: "線のみ",
  levelAloneTitle: "等圧線のみ：塗りを外し、もう一度押すと戻ります",
  creditsTrigger: "データ出典",
  creditsHeading: "データ出典とクレジット",
  creditsGfs: "予報データ：GFS 0.25° および sflux",
  creditsHrrr: "予報データ：HRRR 3 km、米国本土",
  creditsGefsAero: "エーロゾル予報：GEFS-Aerosols 0.25°、光学的厚さと地上 PM",
  creditsCmaDust: "ダスト予報：CMA-CW v1.0/DUST（WMO SDS-WAS アジアセンター）0.15°、アジア域、WMO WIS2 経由",
  creditsSilam: "大気質予報：FMI SILAM v6.1 全球 0.2°、CC BY 4.0",
  creditsCfs: "季節予報：CFSv2、9 か月、6 時間間隔",
  creditsEcmwf: "改変した ECMWF データを含む（CC BY 4.0）",
  creditsIfsHres: "ECMWF IFS を ECMWF が提供、CC BY 4.0 に基づき改変（Open-Meteo 経由）、IFS HRES 約 9 km を 0.1° に再サンプリング",
  creditsMrms: "レーダー観測：MRMS、米国本土",
  creditsNexrad: "単一サイトレーダー：反射強度とドップラー速度、米国",
  creditsJma: "レーダー降水：気象庁ナウキャスト、日本（再格子化）",
  creditsHimawari: "衛星画像：ひまわり9号 AHI、気象庁、NOAA オープンデータ経由（再投影）",
  creditsGoes: "衛星画像：GOES-19 東・GOES-18 西 ABI、NOAA NESDIS、NOAA オープンデータ経由（再投影）",
  creditsMeteosat: "衛星画像：EUMETSAT Meteosat データを加工して使用 {year}、Meteosat-12 FCI、毎正時の走査、CC-BY-4.0（再投影）",
  creditsSounding: "ラジオゾンデ観測：GTS TEMP 電文（WIS2 経由）、各国気象機関",
  creditsAirport: "空港 METAR・TAF：各国気象機関（NOAA/NWS AWC 経由）",
  creditsFirms: "アクティブ火災：LANCE FIRMS NRT、VIIRS 375 m と MODIS、NASA ESDIS",
  creditsGibs: "日次画像：MODIS・VIIRS 補正反射率、NASA ESDIS",
  creditsRadar: "レーダー合成図",
  creditsBasemap: "ベースマップ：© OpenStreetMap 貢献者",
  creditsTerrain: "地形陰影：© Mapterhorn、標高データ出典一覧",
  creditsPeaks: "山名と標高：CC0",
  creditsCode: "ソースコード：ringsaturn/xue",
  caseTag: "事例",
  caseSummaryAria: "事例の概要",
  runCycle: "初期時刻",
  recordSpan: "記録期間",
  latestObservation: "最新の観測",
  latestNowcast: "最新のナウキャスト",
  awaitingData: "データ待機中",
  validTimeLabel: "対象時刻",
  observationTimeLabel: "観測時刻",
  statsAria: "詳細統計情報",
  statsCloseAria: "詳細統計情報を閉じる",
  bufferedFrames: "取得フレーム",
  downloadedBytes: "受信量",
  formatLabel: "形式",
  formatZarr: "Zarr",
  preloadProgressAria: "予報データの先読み進捗",
  statDataset: "データセット",
  statGrid: "格子",
  statFrameCache: "フレームキャッシュ",
  statDecodeTime: "復号時間",
  statDecodeRate: "復号速度",
  statViewport: "表示域サンプリング",
  statConnection: "接続",
  awaitingManifest: "マニフェスト待機中",
  legendPrateAria: "降水強度のカラースケール",
  timelineAria: "予報時刻の操作",
  playAnimation: "アニメーションを再生",
  pauseAnimation: "アニメーションを一時停止",
  playbackSpeed: "再生速度",
  exportOpenAria: "ループを書き出す",
  exportSheetAria: "ループを書き出す",
  exportHeading: "書き出し",
  exportFormat: "形式",
  exportSize: "サイズ",
  exportFps: "フレームレート",
  exportRange: "範囲",
  exportFrom: "開始",
  exportTo: "終了",
  exportRun: "書き出す",
  exportCancel: "中止",
  exportSummary: "{size}、{frames} フレーム、{seconds} 秒、約 {bytes}",
  exportCapturing: "取り込み中 {done}/{total}",
  exportEncoding: "エンコード中 {percent}%",
  exportFailed: "書き出しに失敗しました",
  readingManifest: "マニフェストを読み込み中",
  forecastHourAria: "予報時間",
  forecastDaysAria: "日別の予報区間",
  observationDaysAria: "日別の区間",
  mapMenuAria: "地図メニュー",
  menuStats: "詳細統計情報",
  menuCopyDebug: "デバッグ情報をコピー",
  errorTitle: "データを表示できません",
  retry: "再読み込み",
  langPickerAria: "言語",
  langPickerHeading: "言語",
  themeToggleAria: "ライト / ダークを切り替え",
  viewGlobeAria: "地球儀表示",
  viewTerrainAria: "3D 地形",
  viewContoursAria: "等高線",
  viewResetNorthAria: "北を上に戻す",
  viewResetPitchAria: "傾きをリセット",
  viewBoxAria: "嵐のクローズアップ：範囲をドラッグ",
  viewSectionAria: "鉛直断面：線をドラッグ",
  viewDistanceAria: "距離を測る：地点をクリック、最後の点をもう一度クリックで終了",
  viewAreaAria: "面積を測る：頂点をクリック、最初か最後の点をもう一度クリックで終了",
  particlesToggle: "粒子アニメーション",
  particlesToggleAria: "風の粒子アニメーションを切り替え",

  dataInterrupted: "データの読み込みが中断しました",
  errorHint: "{message}。make mvp を実行し、make serve でページを開いているか確認してください。",
  loadFailed: "読み込み失敗",
  webglLost: "WebGL が使えません。ブラウザを完全に終了して開き直してください",
  saveData: "節約",
  debugCopied: "デバッグ情報をコピーしました",
  copyFailed: "コピーに失敗しました",
  bundleResident: "バンドルをすべて保持しました",
  viewportResident: "表示域はすべて読み込み済みです",
  streamingOnDemand: "必要な分だけ配信中",
  receivingBundle: "予報バンドルを受信中",
  receivingBundlePercent: "バンドルを受信中 {percent}%",
  readingIndex: "データ索引を読み込み中",
  initializingDecoder: "デコーダーを初期化中",
  framesReady: "{count} フレーム準備完了",
  readingData: "データを読み込み中",
  bundleLoadFailed: "予報バンドルの読み込みに失敗しました",
  workerStartFailed: "デコード Worker の起動に失敗しました",
  decodeFailed: "復号に失敗しました",
  frameDecodeFailed: "フレームの復号に失敗しました: {message}",
  legendAria: "{label}のカラースケール",
  legendInflow: "暖湿流",
  legendFront: "前線帯（θe勾配）",
  legendHotspot: "火災高温点（3.9 µm 文脈判定）",
  legendFfwi: "Fosberg 火災気象指数",
  legendFwalert: "相対湿度 30 % 未満かつ突風 10 m/s 以上",
  legendDustDust: "ダスト",
  legendDustThickHigh: "厚い上層雲",
  legendDustThinHigh: "薄い上層雲",
  legendDustMid: "中層雲",
  legendDustLow: "暖かい下層雲",
  legendDustDesert: "高温の砂漠地表",
  legendDustSurface: "海面と植生地",
  legendTruecolorCloud: "雲と雪",
  legendTruecolorSea: "海面",
  legendTruecolorLand: "陸地と植生",
  legendTruecolorNightCloud: "夜間の雲（赤外）",
  legendTruecolorNightGround: "夜間の晴天域",
  legendPtypeRain: "雨",
  legendPtypeFreezingRain: "着氷性の雨",
  legendPtypeSnow: "雪",
  legendPtypeIcePellets: "凍雨",
  legendDisrpBelow: "1.5年確率未満",
  legendDisrp1p5: "≥ 1.5年確率",
  legendDisrp2: "≥ 2年確率",
  legendDisrp5: "≥ 5年確率",
  legendDisrp20: "≥ 20年確率",
  legendCatLight: "弱い",
  legendCatModerate: "並",
  legendCatModerateSevere: "並〜強い",
  legendCatSevere: "強い",
  varLabelTmp2m: "地上 2 m 気温",
  varLabelPrate: "降水強度",
  varLabelDswrf: "日射量",
  varLabelWind10m: "地上 10 m 風",
  varLabelWind80m: "80 m 風",
  varLabelWind100m: "100 m 風",
  varLabelCref: "レーダー合成反射強度",
  varLabelRefl3d: "3次元レーダー反射強度",
  varLabelCloud3d: "3次元雲水量",
  varLabelOrog: "地形高度",
  varLabelIr104: "赤外画像（10.4 µm 輝度温度）",
  varLabelIr039: "短波赤外（3.9 µm 輝度温度）",
  varLabelDustrgb: "ダスト RGB（赤外合成）",
  varLabelDustcf: "DEBRA ダスト信頼度",
  varLabelZhouye: "ZHOUYE（昼夜）ダスト信頼度",
  varLabelTruecolor: "トゥルーカラー（日中は可視、夜間は赤外の雲）",
  varLabelGust: "突風",
  varLabelTcdc: "全雲量",
  varLabelCape: "対流有効位置エネルギー",
  varLabelCin: "対流抑制",
  varLabelVis: "視程",
  varLabelDpt2m: "2 m 露点温度",
  varLabelAptmp2m: "2 m 体感温度",
  varLabelLcdc: "下層雲量",
  varLabelMcdc: "中層雲量",
  varLabelHcdc: "上層雲量",
  varLabelPwat: "可降水量",
  varLabelHpbl: "大気境界層高度",
  varLabelPtype: "降水種別",
  varLabelTmpsfc: "海面水温（陸上は地表面温度）",
  varLabelIcec: "海氷密接度",
  varLabelIcetk: "海氷の厚さ",
  varLabelWave: "波浪（有義波高と波向）",
  varLabelHtsgw: "有義波高",
  varLabelPerpw: "卓越波周期",
  varLabelDirpw: "卓越波向",
  varLabelWindwave: "風浪（有義波高と波向）",
  varLabelSwell: "うねり（有義波高と波向、第1成分）",
  varLabelWvhgt: "風浪の有義波高",
  varLabelWvper: "風浪の平均周期",
  varLabelWvdir: "風浪の波向",
  varLabelSwhgt: "うねりの有義波高（第1成分）",
  varLabelSwper: "うねりの平均周期（第1成分）",
  varLabelSwdir: "うねりの波向（第1成分）",
  varLabelAod: "550 nm エーロゾル光学的厚さ",
  varLabelAoddust: "ダスト光学的厚さ",
  varLabelAodsalt: "海塩光学的厚さ",
  varLabelAodsulf: "硫酸塩光学的厚さ",
  varLabelAodorg: "有機炭素光学的厚さ",
  varLabelAodbc: "黒色炭素光学的厚さ",
  varLabelPm25: "地上 PM2.5 濃度",
  varLabelPm10: "地上 PM10 濃度",
  varLabelPm10dust: "地上ダスト PM10 濃度",
  varLabelDustsfc: "地上ダスト濃度",
  varLabelTsoil1: "地温・第1層",
  varLabelTsoil2: "地温・第2層",
  varLabelTsoil3: "地温・第3層",
  varLabelTsoil4: "地温・第4層",
  varLabelSoilw1: "土壌水分（体積含水率）・第1層",
  varLabelSoilw2: "土壌水分（体積含水率）・第2層",
  varLabelSoilw3: "土壌水分（体積含水率）・第3層",
  varLabelSoilw4: "土壌水分（体積含水率）・第4層",
  varLabelPrmsl: "海面更正気圧",
  varLabelHeightAtLevel: "{level} hPa ジオポテンシャル高度",
  varLabelTempAtLevel: "{level} hPa 気温",
  varLabelRhAtLevel: "{level} hPa 相対湿度",
  varLabelSpfhAtLevel: "{level} hPa 比湿",
  varLabelWindAtLevel: "{level} hPa 風",
  varLabelQfluxAtLevel: "{level} hPa 水蒸気フラックス",
  varLabelVvelAtLevel: "{level} hPa 鉛直速度",
  varLabelThetaeAtLevel: "{level} hPa 相当温位",
  varLabelCatAtLevel: "{level} hPa 晴天乱気流（EDR）",
  legendSubtropicalHigh: "588 線",
  webglUnavailable: "このブラウザーは WebGL2 コンテキストを提供していません",
  pointerRequestFailed: "ライブポインターの要求が HTTP {status} を返しました",
  manifestRequestFailed: "マニフェストの要求が HTTP {status} を返しました",
  bundleRequestFailed: "バンドルの要求が HTTP {status} を返しました",
  bundleTooLong: "バンドルがマニフェストの宣言した長さを超えています",
  bundleLengthMismatch: "バンドルの長さがマニフェストと一致しません",
  bundleChecksumMismatch: "バンドルのチェックサムが一致しません",
  bundleRunMismatch: "バンドルの初期時刻がマニフェストと一致しません",
  bundleMissingVariable: "バンドルに変数 {id} がありません",
  manifestMissingBundle: "マニフェストに変数 {id} のバンドルがありません",
  mosaicNoMembers: "モザイクを構成する衛星データがひとつも利用できません",

  probeAria: "地点データの時系列",
  probeHint: "再生またはスクラブで時系列を埋めてください",
  probeComplete: "時系列がそろいました",
  probeOutside: "この地点はデータセットの格子の外です",
  probeNoData: "このフレームにデータはありません",
  probeAwaiting: "このフレームの復号を待っています",
  probeModelElevationLabel: "モデル",
  probeDemLabel: "DEM",
  probeCloseAria: "地点データを閉じる",
  cardCloseAria: "カードを閉じる",

  centerHigh: "高",
  centerLow: "低",

  showcaseLink: "過去事例",
  showcaseBack: "← 事例一覧",
  showcaseHome: "最新予報",
  showcaseTitle: "過去事例集",
  showcaseHeading: "過去の気象現象を再生する",
  showcaseArchive: "アーカイブ",
  showcaseIntro:
    "それぞれの事例は過去の気象現象を切り出したものです。保存された予報、あるいは観測を同じエンコーダーに通し、現象が起きた領域と時間帯だけを切り取ってあります。",
  showcaseMetaDescription:
    "過去の気象現象の再生:台風・大雨・熱波などを切り出した予報とレーダーのデータセット",
  showcaseLoading: "事例カタログを読み込み中",
  showcaseEmpty: "公開されている事例はまだありません",
  showcaseLoadFailed: "事例カタログの読み込みに失敗しました: {message}",
  showcaseCaseMissing: "{id} という事例はありません",
  showcaseEventLabel: "現象",
  showcaseRunLabel: "初期時刻",
  showcaseSeriesLabel: "開始",
  showcaseRangeLabel: "予報時間",
  showcaseSpanLabel: "期間",
  showcaseRegionLabel: "領域",
  showcaseGridLabel: "格子",
  showcaseSizeLabel: "容量",
  showcaseVariablesLabel: "要素",
  showcaseHours: "{count} 時間",
  showcaseCaseAria: "事例 {title} を開く",
  showcaseListAria: "過去事例の一覧",

  tcTileTip: "熱帯低気圧",
  varTc: "進路",
  glyphTc: "台",
  tcSheetAria: "熱帯低気圧",
  tcHeading: "熱帯低気圧",
  tcAllSystems: "すべての番号付き擾乱",
  tcNone: "現在活動中の擾乱はありません",
  tcUnnamed: "名称未定",
  tcDisturbances: "擾乱・熱帯低気圧",
  tcPotential: "発生の可能性",
  tcPotentialShow: "モデルのみの {count} 系統を表示",
  tcModelOnly: "モデルのみ",
  tcAgencies: "公式予報",
  tcModels: "モデル進路",
  tcMembers: "アンサンブルメンバー",
  tcBest: "ベストトラック",
  tcOptionsAria: "台風の表示設定",
  tcHistoryHeading: "過去の熱帯低気圧",
  tcHistoryIntro: "アーカイブにある番号付きの嵐すべて：各機関のベストトラック、その嵐に出された予報、それぞれのずれ。",
  tcHistorySeasonsAria: "シーズン",
  tcHistoryBasinsAria: "海域",
  tcHistoryAll: "すべて",
  tcHistoryEmpty: "このシーズンと海域には予報のある嵐がありません",
  tcHistoryStormAria: "{name} を開く",
  tcHistorySouthernNote: "南半球のシーズンは7月から翌年6月までで、終わる年で呼びます。{season}年シーズンは{from}〜{to}です。",
  tcPageTitle: "過去の熱帯低気圧",
  tcPageMetaDescription: "過去の熱帯低気圧：各機関のベストトラック、アーカイブされたすべての予報、それぞれのずれ。",
  tcPageLoading: "嵐を読み込み中",
  tcPageMissing: "アーカイブに {id} という嵐はありません",
  tcPageFailed: "嵐の読み込みに失敗しました：{message}",
  tcPageIssue: "時刻",
  tcPageNoForecast: "この時刻の予報なし",
  tcPagePrev: "前の初期時刻",
  tcPageNext: "次の初期時刻",
  tcPageSources: "表示する経路",
  tcPageErrorsHeading: "進路誤差（km）",
  tcPageTruth: "照合するベストトラック",
  tcPageSource: "予報元",
  tcPageErrorsMean: "嵐全体の平均",
  tcPageErrorsThis: "地図上の予報",
  tcPageErrorsNone: "この嵐の予報はまだこのベストトラックと照合されていません",
  tcPageNote: "総観時刻におけるベストトラックとの距離で、熱帯または亜熱帯低気圧である間だけを数えます。アンサンブルは平均で評価します。公式予報は同じ時刻に始まったモデルと並べていますが、モデルは公式予報の発表後に計算を終えたものです。",
  tcPageId: "ATCF 番号",
  tcPageLife: "存続期間",
  tcPagePeak: "最大風速",
  tcPageForecasts: "予報数",
  tcCardSeasons: "シーズン",
  tcCardStorms: "嵐",
  tcPageDetails: "嵐の詳細ページ",
  tcPageSeasonList: "このシーズンの嵐一覧",
  tcCardBrowse: "シーズン別に見る",
  tcPageRadii: "強風域",
  tcLegendIntensity: "強度：米国ベストトラック、1分間平均風速",

  soundingTileTip: "ラジオゾンデ観測",
  varSounding: "高層",
  glyphSounding: "探",
  airportTileTip: "空港の観測",
  varAirport: "METAR",
  glyphAirport: "空",
  synopTileTip: "地上気象観測所",
  varSynop: "地上",
  glyphSynop: "地",
  radarTileTip: "単一サイトのレーダー",
  varRadarSite: "サイト",
  glyphRadarSite: "雷",
  radarProductAria: "レーダープロダクト",
  radarLatest: "最新",
  radarCloseAria: "合成図に戻る",
  radarReflectivity: "反射強度",
  radarVelocity: "ドップラー速度",
  stationSounding: "高層観測",
  stationAirport: "空港",
  stationObserved: "観測",
  stationFreezingLevel: "0℃高度",
  stationPw: "可降水量",
  stationCategory: "飛行区分",
  stationVisibility: "視程",
  stationQnh: "QNH",
  stationLevels: "層数",
  stationSynop: "気象観測所",
  stationHumidity: "湿度",
  stationPrecipitation: "降水量",
  stationPressure: "現地気圧",
  stationSeaLevelPressure: "海面気圧",
  stationSunshine: "日照時間",
  stationSnowDepth: "積雪深",
  stationElevation: "標高",
  stationOpenSounding: "探空図を開く",
  stationPinHere: "ここにピン",
  fireTileTip: "火災検知（NASA FIRMS、直近 24 時間）",
  varFire: "火災",
  glyphFire: "火",
  fireDetection: "火災検知",
  fireAcquired: "観測時刻",
  fireRadiativePower: "放射エネルギー",
  fireBrightness: "輝度温度",
  fireConfidence: "信頼度",
  fireConfidenceLow: "低",
  fireConfidenceNominal: "中",
  fireConfidenceHigh: "高",
  fireOverpass: "通過",
  fireDay: "昼",
  fireNight: "夜",
  aqTileTip: "大気汚染測定局（PM2.5）",
  varAq: "PM2.5",
  glyphAq: "気",
  aqStation: "大気質",
  aqAgency: "運営機関",
  aqNetwork: "ネットワーク",
  aqPreliminary: "速報値：未確定で、変更されることがあります",
  aqDayRange: "PM2.5（過去 24 時間）",
  aqNearest: "最寄りの大気汚染測定局 {km} km",
  alertsTileTip: "発表中の気象警報・注意報",
  varAlerts: "警報",
  glyphAlerts: "警",
  alertsCardTitle: "警報・注意報",
  alertsInForceNow: "発表中",
  alertsAsOf: "{time} 時点",
  alertsLevel: "レベル {level}",
  alertsUntilCancelled: "解除まで",
  alertsIssued: "{time} 発表",
  alertCategoryRain: "大雨",
  alertCategoryFlood: "洪水",
  alertCategoryLandslide: "土砂災害",
  alertCategoryWind: "風",
  alertCategoryThunderstorm: "雷",
  alertCategorySnowIce: "雪・着氷",
  alertCategoryHeat: "高温",
  alertCategoryCold: "低温",
  alertCategoryFog: "霧",
  alertCategoryDust: "黄砂・砂塵",
  alertCategoryFire: "乾燥・火災",
  alertCategoryAir: "大気質",
  alertCategoryCoastal: "沿岸",
  alertCategoryMarine: "海上",
  alertCategoryTsunami: "津波",
  alertCategoryOther: "その他",
  markerPlace: "地点",
  markerEvent: "出来事",
  markerSources: "出典",
  caseMarkersAria: "この事例の地点と出来事",
  casePartsAria: "この事象の各部",
  riverHeading: "河川流量",
  riverTracksAria: "水文モデルの実行",
  riverTrackAnalysis: "解析",
  riverTrackForecast: "予報 {cycle}",
  riverKeyAria: "平常時流量に対する比",
  riverRatio2: "平常の 2 倍未満",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "流量で着色（色は図層の凡例と共通）",
  riverExtents: "浸水範囲",
  riverGaugeHint: "円は流量観測所です。クリックでハイドログラフを表示。",
  riverObserved: "観測",
  riverModelled: "モデル",
  riverPeaks: "報告されたピーク",
  riverGaugeLoading: "読み込み中…",
  riverGaugeUnavailable: "取得できません",

  soundingObserved: "実測",
  soundingModel: "モデル",
  soundingNoModel: "12 時間以内にモデルなし",
  soundingLoading: "ゾンデを読み込み中…",
  soundingUnavailable: "ゾンデを取得できません",
  soundingExpand: "全体図",
  soundingClose: "閉じる",
  soundingSheetHeading: "高層観測",
  soundingSheetAria: "高層観測グラフ",

  // The comparison page (compare.html).
  compareLink: "比較",
  compareTitle: "予報を比較",
  compareHeading: "モデル比較",
  compareEyebrow: "地点",
  compareIntro:
    "ひとつの地点、ひとつの時間軸に、稼働中の予報モデルをすべて並べます。各モデルがこの先の時間をどう予報しているかを、最寄りの空港の実況と並べて読めます。",
  compareMetaDescription:
    "GFS・ECMWF・AIFS・IFS HRES・HRRR の予報を一地点で 1 時間ごとに比較し、最寄りの空港の METAR と照らし合わせます。",
  compareLatitude: "緯度",
  compareLongitude: "経度",
  compareLocate: "現在地を使う",
  compareLocateFailed: "位置情報を取得できません",
  compareOnMap: "地図で見る",
  compareSpan5: "5 日間",
  compareSpan15: "15 日間",
  compareFieldsAria: "比較する要素",
  compareModelsAria: "モデル比較ブロック",
  compareLoading: "{model} を読み込み中…",
  compareModelFailed: "{model}: {message}",
  compareOffGrid: "このモデルの格子の外",
  compareNoModels: "この地点を覆うモデルがありません",
  compareHide: "隠す",
  compareShow: "表示",
  comparePin: "先頭に固定",
  compareHidden: "非表示のモデル",
  compareRun: "初期時刻",
  compareObservationsFrom: "{icao} の実況",
  compareNoAirport: "40 km 以内に空港がありません",
  compareHours: "時刻",
  compareNow: "現在",
  compareCells: "各値はそのモデル自身の格子で地点に最も近いセルの値で、内挿はしていません。時刻はお使いのタイムゾーンで表示します。",
  metricsMetaDescription: "Xue の各予報ランが公開された時刻の実測値。公開ワークフローの記録から、初期時刻からの遅延、欠けたサイクル、ERCOT 前日市場の締切時点で公開済みだったランを示します。",
  metricsHeading: "ランの到着",
  metricsEyebrow: "実測",
  metricsIntro: "各予報ランがこのサイトで公開された時刻を、公開ワークフロー自身の記録から読み取ったものです。最新ポインタが書き込まれた時刻と、それがモデルの初期時刻から何時間後だったかを示します。",
  metricsNotSla: "これは実測値であり、サービス水準ではありません。Xue は可用性を保証しません。",
  metricsGenerated: "{time} 作成、直近 {days} 日",
  metricsLoading: "統計を読み込み中…",
  metricsEmpty: "統計はまだありません。統計は公開ワークフローから 6 時間ごとに作成されます。次の作成後にもう一度ご覧ください。",
  metricsFailed: "統計を読み込めませんでした: {message}",
  metricsSourcesHeading: "ソース別",
  metricsLatencyNote: "遅延は初期時刻からランが公開された時刻までなので、モデル自身の計算時間を含みます。時刻はすべて UTC です。",
  metricsTimelineNote: "各帯は集計期間全体です。公開されたサイクルごとに 1 本の棒を初期時刻の位置に描き、高さは遅延（そのソース自身の最長を満幅とする）です。基線の下の印は届かなかったサイクルです。",
  metricsTypicalNote: "* 上流の目安：モデル自身のデータが初期時刻から通常どれくらいで揃うかの経験値で、実測ではありません。目安がないものは空欄です。",
  metricsTimelineAria: "集計期間内の {model} の到着",
  metricsCadence: "{hours} 時間ごと",
  metricsLatest: "最新ラン",
  metricsLanded: "公開時刻",
  metricsLatency: "遅延",
  metricsMedian: "中央値",
  metricsMax: "最大",
  metricsTypical: "上流の目安",
  metricsCycles: "到着したサイクル",
  metricsMissing: "欠落",
  metricsMissingList: "欠けたサイクル",
  metricsRuns: "ワークフロー実行",
  metricsOutcomeLanded: "公開",
  metricsOutcomeSkipped: "スキップ",
  metricsOutcomeDryRun: "ドライラン",
  metricsOutcomeFailed: "失敗",
  metricsBacklog: "未読のワークフロー実行が {count} 件あります。次の作成時に読み込みます。",
  metricsDeadlinesHeading: "締切時点",
  metricsDeadlineIntro: "現地の日ごとに、締切時刻に公開済みだった最新のランと、その時点での初期時刻からの経過時間。",
  metricsSource: "ソース",
  metricsCommonest: "通常",
  metricsNoneLive: "なし",
  glyphAurora: "A",
  varAurora: "確率",
  varDis06: "流量",
  varDisrp: "再現期間",
  varUpstream: "集水",
  fieldGroupSpace: "宇宙天気",
  fieldGroupFire: "火災",
  modelGroupForecast: "数値予報モデル",
  modelGroupRadar: "レーダー",
  varLabelAurora: "オーロラ可視確率",
  varLabelDis06: "河川流量（6時間平均）",
  varLabelDisrp: "再現期間クラス",
  varLabelUpstream: "上流集水面積",
  creditsAurora: "宇宙天気：オーロラ可視確率、NOAA SWPC OVATION モデル",
  creditsEfas: "河川流量：Copernicus EMS EFAS v5、ヨーロッパ 1′（事例のみ）",
  creditsEra5: "再解析：Copernicus C3S ERA5（ECMWF）、全球 0.25°、毎時、CC-BY-4.0（事例のみ）",
  creditsCams: "エアロゾル解析：Copernicus CAMS（ECMWF）、全球 0.4°、3 時間ごと、CC-BY-4.0（事例のみ）",
};
